module.exports = __webpack_public_path__ + "static/media/MP4-Video.9c35eacf.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/static/MP4-Video.mp4
// module id = 331
// module chunks = 0